export default __webpack_public_path__ + "static/media/gp resources.50ba655d.svg";